module.exports = __webpack_public_path__ + "static/media/RN-2025-01.73a4829a.jpg";